import highlightTitleIcon from "../../icons/highlightTitleIcon.svg"
import formatBoldIcon from "../../icons/formatBoldIcon.svg"
import lineHeightIcon from "../../icons/lineHeightIcon.svg"
import letterSpacingIcon from "../../icons/letterSpacingIcon.svg"
import dyslexiaFontIcon from "../../icons/dyslexiaFontIcon.svg"
import highlightLinksIcon from "../../icons/highlightLinksIcon.svg"
import screenReaderIcon from "../../icons/ScreenReaderIcon.svg"

export default [
    {
        label: 'Font Weight',
        key: 'font-weight',
        icon: formatBoldIcon,
    },
    {
        label: 'Line Height',
        key: 'line-height',
        icon: lineHeightIcon
    },
    {
        label: 'Letter Spacing',
        key: 'letter-spacing',
        icon: letterSpacingIcon,
    },
    {
        label: 'Dyslexia Font',
        key: 'readable-font',
        icon: dyslexiaFontIcon,
    },
    {
        label: 'Highlight Links',
        key: 'highlight-links',
        icon: highlightLinksIcon
    },
    {
        label: 'Highlight Title',
        key: 'highlight-title',
        icon: highlightTitleIcon,
    },
    {
        label: 'Screen Reader',
        key: 'new-button',
        icon: screenReaderIcon,
    },
]